// Microtip (Tooltip)
let abbreviationElements = document.getElementsByClassName('abbreviation');

if(typeof abbreviationElements !== 'undefined') {
    for (let i=0; i<abbreviationElements.length; i++) {
        let currentText = abbreviationElements[i].textContent || abbreviationElements[i].innerText || "";
        currentText = currentText.trim();

        for (const key in abbreviations) {
            if(key === currentText) {
                abbreviationElements[i].setAttribute('aria-label', abbreviations[key]);
                abbreviationElements[i].setAttribute('data-microtip-size', 'large');
                abbreviationElements[i].setAttribute('data-microtip-position', 'top');
                abbreviationElements[i].setAttribute('role', 'tooltip');
                break;
            }
        }
    }
}

$('.abbreviation').hover(function() {
    let abbreviationAfterWidth = 260+18+18;

    let abbreviation = $(this);
    let abbreviationOffset = abbreviation.offset();
    let currentPageWidth = $(window).width();
    abbreviation.removeClass().addClass('abbreviation');

    let abbreviationCenterX = abbreviationOffset.left + (abbreviation.width()/2);
    let abbreviationAfterLeft = abbreviationCenterX - (abbreviationAfterWidth/2);
    let abbreviationAfterRight = abbreviationCenterX + (abbreviationAfterWidth/2);

    if(abbreviationAfterLeft < 15) {
        let pxDifference = abbreviationAfterLeft * -1;
        let percentDifference = Math.ceil( pxDifference / ( abbreviationAfterWidth / 100 ) );
        abbreviation.addClass('shiftAfter'+(50 - percentDifference - 4));
    } else if((currentPageWidth - abbreviationAfterRight) < 15) {
        let pxDifference = (currentPageWidth - abbreviationAfterRight) * -1;
        let percentDifference = Math.ceil( pxDifference / ( abbreviationAfterWidth / 100 ) );
        abbreviation.addClass('shiftAfter'+(50 + percentDifference + 6));
    }
}, function() {});
